var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#007DAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99991 9V8.6C9.99991 7.715 9.99991 7 11.5999 7H12.3999C13.9999 7 13.9999 7.715 13.9999 8.6V9M12.9999 13.01C12.9999 13.005 12.9999 13.005 12.9999 13V12.5C12.9999 12 12.9999 12 12.4999 12H11.4999C10.9999 12 10.9999 12 10.9999 12.5V13.015M12.9999 13.01C12.9999 13.555 12.9949 14 11.9999 14C11.0099 14 10.9999 13.56 10.9999 13.015M12.9999 13.01C14.3499 12.84 15.6699 12.34 16.8249 11.5M10.9999 13.015C9.70491 12.87 8.43491 12.405 7.30991 11.635M9.99991 17H13.9999C16.0099 17 16.3699 16.195 16.4749 15.215L16.8499 11.215C16.9849 9.995 16.6349 9 14.4999 9H9.49991C7.36491 9 7.01491 9.995 7.14991 11.215L7.52491 15.215C7.62991 16.195 7.98991 17 9.99991 17Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.83852b26f69ae81264ab75fa24ad601a.svg";
export { ForwardRef as ReactComponent };